import { gql } from '@apollo/client'

export interface IAssignUserToParkingPoolProfileData {
  updateParkingPoolProfile: {
    numUids: number[]
    parkingPoolProfile: {
      users: {
        login: string
      }[]
    }[]
  }
}

export interface IAssignUserToParkingPoolProfileVars {
  id: string
  login: string
}

export const ASSIGN_USER_TO_PARKING_POOL_PROFILE = gql`
  mutation updateParkingPoolProfile($id: ID!, $login: String) {
    updateParkingPoolProfile(
      input: { filter: { id: [$id] }, set: { users: { login: $login } } }
    ) {
      numUids
      parkingPoolProfile @cascade(fields: "users") {
        users(filter: { login: { eq: $login } }) {
          login
        }
      }
    }
  }
`
